/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

export function planUpdatedAction(payload) {
  return {
    type: "PLAN_UPDATED",
    payload,
  };
}

const defaultState = {
  plan: "",
  subscriptionStatus: "",
};

function isTrialActive(createdAt) {
  const twoWeeksInMs = 60 * 60 * 24 * 14 * 1000;
  const msSinceStart = Date.now() - createdAt;
  return twoWeeksInMs - msSinceStart > 0 ? true : false;
}

export function planReducer(previousState = defaultState, { type, payload }) {
  if (type === planUpdatedAction().type) {
    let plan = payload.plan === undefined ? previousState.plan : payload.plan;
    if (!isTrialActive(payload.createdAt) && plan === "trial") plan = "none";
    return {
      plan: plan,
      subscriptionStatus: payload.subscriptionStatus,
    };
  }
  return previousState;
}
